import React from 'react'
import PropTypes from 'prop-types'

const Cash = (props) => {
	const { isSelected, onSelect, setPayment } = props
	setPayment(0)
	return (
		<div className='payment-method' onClick={onSelect}>
			<div className='description'>
				<div>
					<i
						className={`round-check-icon -${
							isSelected ? 'checked' : 'unchecked'
						}`}
					/>
					<i className='cash-icon' />
					<div className='info'>
						<span className='text-13px-700 color-black-light name'>
							Contraentrega - Efectivo
						</span>
					</div>
				</div>
			</div>
		</div>
	)
}
Cash.propTypes = {
	isSelected: PropTypes.bool.isRequired,
	onSelect: PropTypes.func,
	setPayment: PropTypes.func
}
Cash.defaultProps = {
	setPayment: () => {}
}

export default Cash
